import React, { useState } from "react";
import PropsTypes from "prop-types";
import Icon from "@material-ui/core/Icon/index";
import Hidden from "@material-ui/core/Hidden/Hidden";
import MenuItem from "@material-ui/core/MenuItem/MenuItem";
import Menu from "@material-ui/core/Menu/Menu";
import IconButton from "@material-ui/core/IconButton/IconButton";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@material-ui/core/styles";
import { useSelector } from "react-redux";
import sum from "lodash/sum";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles((theme) => ({
  iconHover: {
    margin: theme.spacing(1),
    textAlign: "center",
    verticalAlign: "middle",
    lineHeight: "24px",
    width: "24px",
    height: "24px",
    "&:hover": {
      opacity: 0.5,
      cursor: "pointer",
    },
  },
  root: {
    whiteSpace: "nowrap",
  },
  ToolbarButton: {
    padding: 0,
  },
  ToolbarIconButton: {
    height: 32,
    width: 32,
    padding: 8,
    "& span": {
      fontSize: 24,
      color: theme.palette.primary.darkText,
    },
  },
  MenuItemOption: {
    "@media (hover: none) , (pointer: coarse)": {
      "&:focus": {
        backgroundColor: "#fff",
      },
    },
  },
  toolTitle: {
    alignSelf: "center",
    overflow: "hidden",
    textOverflow: "ellipsis",
    width: 175,
  },
}));
const ITEM_HEIGHT = 52;

const ToolbarList = (props) => {
  const classes = useStyles(props);
  const { fields, doubleShelf } = useSelector((state) => state.Artus);
  const configuration = useSelector((state) => {
    return state.Configuration.configuration;
  });
  const itemIdentifier = configuration && configuration.item ? configuration.item.identifier : "";
  const { t } = useTranslation("settingsArtus");
  const palletSum = sum(
    fields.map((field) => {
      const fieldWidth = Number(field.width.match(/\d+/));
      const fieldSupportBars = Number(field.supportBars.match(/\d+/));
      const amountSingleShelf =
        (fieldWidth === 2700 ? 3 : fieldWidth === 3600 ? 4 : 2) * (fieldSupportBars + 1);
      const amountDoubleShelf = 2 * amountSingleShelf;
      return doubleShelf ? amountDoubleShelf : amountSingleShelf;
    })
  );
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const { tools } = props;
  const open = Boolean(anchorEl);
  const toolbarMobileIcon = !open ? "menu" : "close";
  return (
    <div className={classes.root}>
      {tools && (
        <Hidden xsDown>
          {tools.map((tool) => {
            return (
              <Icon
                title={t(tool.title)}
                key={tool.key}
                className={classes.iconHover}
                onClick={tool.function}
              >
                {tool.identifier}
              </Icon>
            );
          })}
        </Hidden>
      )}
      <Hidden smUp>
        <div style={{ display: "flex", alignItems: "center" }}>
          {itemIdentifier.includes("artus") && (
            <Typography className={classes.paletteInfo} style={{ paddingRight: 20 }} variant="body1">
              {t("palletBays", { palletSum: palletSum })}
            </Typography>
          )}
          <div>
            <IconButton
              aria-label="Menu"
              aria-haspopup="true"
              classes={{
                root: classes.ToolbarButton,
                label: classes.ToolbarIconButton,
              }}
              onClick={handleClick}
            >
              <Icon>{toolbarMobileIcon}</Icon>
            </IconButton>
            <Menu
              id="long-menu"
              anchorEl={anchorEl}
              open={open}
              getContentAnchorEl={null}
              anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
              transformOrigin={{ vertical: "top", horizontal: "center" }}
              onClose={handleClose}
              PaperProps={{
                style: {
                  maxHeight: ITEM_HEIGHT * 4.5,
                  width: 250,
                },
              }}
            >
              {tools &&
                tools.map((tool) => (
                  <MenuItem className={classes.MenuItemOption} key={tool.key} onClick={handleClose}>
                    <div style={{ display: "flex", width: "100%" }} onClick={tool.function}>
                      <Icon key={tool.key} className={classes.iconHover}>
                        {tool.identifier}
                      </Icon>
                      <div className={classes.toolTitle}>{t(tool.title)}</div>
                    </div>
                  </MenuItem>
                ))}
            </Menu>
          </div>
        </div>
      </Hidden>
    </div>
  );
};

ToolbarList.propTypes = {
  classes: PropsTypes.object,
  tools: PropsTypes.array,
};
export default ToolbarList;
